import { Injectable } from '@angular/core';

import { QueryEntity } from '@datorama/akita';

import { LocationUsersState } from './location-users.state';
import { LocationUsersStore } from './location-users.store';

@Injectable({providedIn: 'root'})
export class LocationUsersQuery extends QueryEntity<LocationUsersState> {
  constructor(protected readonly store: LocationUsersStore) {
    super(store);
  }
}
